// TODO: move these to Reporter model as well
import { ISOstring } from "@dataseat-dsp-client/lib-reporter";
import {
  ANALYTICS_QUERY_MAP,
  FilterCollectionType,
  FILTERS_QUERY_MAP,
  SplitType,
} from "model/AnalyticsPage";
import { ReporterTables } from "model/reporterDb/dbSchema";
import { DimensionIds } from "model/reporterDb/dbTableCampaign";
import { GRANULARITY_TYPES } from "model/reporterDb/granularity";
import { QueryType, TIME_RANGE_EXPR } from "model/reporterDb/query";

interface IGetReporterQueryProps {
  start: ISOstring;
  finish: ISOstring;
  splits: SplitType[];
  filterBy: FilterCollectionType;
  metrics;
  granularity?: GRANULARITY_TYPES;
}

export const getReporterQuery = ({
  start,
  finish,
  splits,
  filterBy,
  metrics,
  granularity = GRANULARITY_TYPES.ALL,
}: IGetReporterQueryProps) => {
  const groupBy = splits
    .map((split) => split.id)
    .filter((s) => s !== DimensionIds.GRANULARITY_COLUMN_ID);

  const where = [
    TIME_RANGE_EXPR(start, finish),
    ...(filterBy ? FILTERS_QUERY_MAP(filterBy) : []),
  ];

  const select = metrics.map((m) => ANALYTICS_QUERY_MAP.SELECT[m.id]);

  const finalQuery: QueryType = {
    from: ReporterTables.Campaign,
    granularity: ANALYTICS_QUERY_MAP.granularity(granularity),
    groupBy: [...groupBy],
    select,
    where,
  };

  finalQuery.orderBy = groupBy.map((gr) => ({
    expr: gr,
    direction: "DESC",
  }));

  return finalQuery;
};
